import React, { useState } from "react"
import ReactMarkdown from "react-markdown"
import trimText from "@lib/trimText"
import Button from "@components/objects/Button/Button"
import arrowDownSmallGreyCircle from "@images/icons/arrowDownSmallGreyCircle.svg"
import * as styles from "./ReadMore.module.scss"

const ReadMore = ({ text, button }) => {
  const [isFull, setIsFull] = useState(false)

  const textArray = trimText(text, 350, 430, 500)

  return (
    <div className={`${styles.ReadMore} ${isFull ? styles.open : ""}`}>
      <ReactMarkdown>{isFull ? text : textArray[0]}</ReactMarkdown>
      {text.length !== textArray[0].length && (
        <Button
          text="Read More"
          design="image"
          image={arrowDownSmallGreyCircle}
          color="grey"
          onClick={() => setIsFull(true)}
          {...button}
        />
      )}
    </div>
  )
}

export default ReadMore
